import { useSelector } from 'react-redux';

import { type State } from 'loot-core/src/client/state-types';

export type SyncServerStatus = 'offline' | 'no-server' | 'online';

export function useSyncServerStatus(): SyncServerStatus {
  const userData = useSelector((state: State) => state.user.data);

  return !userData || userData.offline ? 'offline' : 'online';
}
